Object.defineProperty(exports, "__esModule", { value: true });var _reactNativeDrawerLayout = require('react-native-drawer-layout');var _reactNativeDrawerLayout2 = _interopRequireDefault(_reactNativeDrawerLayout);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}exports.default = _reactNativeDrawerLayout2.default;


// WEBPACK FOOTER //
// ./node_modules/react-native-drawer-layout-polyfill/dist/index.js